export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("usuario"));
  } catch (_error) {
    return null;
  }
};

export const toBool = (value) => value === true || value === "true" || value === 1 || value === "1";

export const getRoleKey = (usuario = getStoredUser()) => {
  if (!usuario) return "";
  return String(
    usuario.role_key ||
      (usuario.tenant && usuario.tenant.role_key) ||
      ""
  ).trim();
};

export const isGestorProyectos = (usuario = getStoredUser()) =>
  getRoleKey(usuario) === "gestor_proyectos" && !toBool(usuario && usuario.is_tenant_admin);

export const isHattTenant = (usuario) => {
  if (!usuario) return false;
  // En empresas SaaS se prioriza el tenant real del usuario.
  // active_tenant_id puede venir de un token/localStorage antiguo y provocar que MINDSHOT se vea como HATT.
  const tenantId = usuario.tenant_id || (usuario.tenant && usuario.tenant.id) || usuario.active_tenant_id;
  const tenantSlug = usuario.tenant && usuario.tenant.slug;
  return Number(tenantId || 0) === 1 || (!tenantId && tenantSlug === "hatt");
};

export const isPlatformAdmin = (usuario = getStoredUser()) => {
  if (!usuario) return false;
  if (toBool(usuario.is_platform_admin)) return true;
  // Compatibilidad: los superadministradores HATT antiguos tenían is_admin=true.
  // Las empresas nuevas NO se crean con is_admin=true, por eso este fallback no abre el panel a tenants externos.
  return toBool(usuario.is_admin) && isHattTenant(usuario);
};

export const hasModule = (moduleKey, usuario = getStoredUser()) => {
  if (!usuario) return false;
  if (isPlatformAdmin(usuario)) return true;
  if (!Array.isArray(usuario.modules)) return isHattTenant(usuario); // compatibilidad solo para HATT legacy
  return usuario.modules.indexOf(moduleKey) !== -1;
};

export const can = (permission, usuario = getStoredUser()) => {
  if (!usuario) return false;
  if (isPlatformAdmin(usuario)) return true;
  if (!Array.isArray(usuario.permissions)) return false;
  return usuario.permissions.indexOf(permission) !== -1;
};

export const tenantName = (usuario = getStoredUser()) =>
  (usuario && usuario.tenant && usuario.tenant.nombre) || "HATT";

export const tenantColor = (usuario = getStoredUser()) =>
  (usuario && usuario.tenant && usuario.tenant.color_primario) || "#123f7a";
